import PrivacyPolicy from '@/assets/volcanobet/pdf/privacy_policy.pdf';
import TermsAndConditions from '@/assets/volcanobet/pdf/terms_and_conditions.pdf';

export default {
  PrivacyPolicy,
  TermsAndConditions,
};
